import { RetailMatchDynamicTextEnum } from "../../Enums/RetailMatchDynamicTextEnum";
import { RetailMatchMetricLevel } from "../../Enums/RetailMatchMetricLevel";
import { RetailMatchMetricTier } from "../../Enums/RetailMatchMetricTier";
import {
    IRetailMatchJobResult,
    IRetailMatchOverview,
    IStoreScoreRecord,
} from "../../Models/Models";

export function getRetailMatchMetricVerbiage(
    value: number,
    level: RetailMatchMetricLevel
): string {
    switch (level) {
        case RetailMatchMetricLevel.Comparable:
            return getRetailMatchComparableVerbiage(value);

        case RetailMatchMetricLevel.Average:
            return getRetailMatchAverageVerbiage(value);

        case RetailMatchMetricLevel.Similarity:
            return getRetailMatchSimilarityVerbiage(value);

        default:
            return "";
    }
}

export function getRetailMatchMetricTierLevel(
    value: number
): RetailMatchMetricTier {
    let tier = RetailMatchMetricTier.Tier4;

    if (value <= 79) {
        tier = RetailMatchMetricTier.Tier1;
    } else if (value >= 80 && value <= 89) {
        tier = RetailMatchMetricTier.Tier2;
    } else if (value >= 90 && value <= 110) {
        tier = RetailMatchMetricTier.Tier3;
    }

    return tier;
}

export function getRetailMatchSimilarityVerbiage(
    value: number
): RetailMatchDynamicTextEnum {
    const tierLevel: RetailMatchMetricTier = getRetailMatchMetricTierLevel(value);

    switch (tierLevel) {
        case RetailMatchMetricTier.Tier1:
            return RetailMatchDynamicTextEnum.NotSimilar;

        case RetailMatchMetricTier.Tier2:
            return RetailMatchDynamicTextEnum.SomewhatSimilar;

        case RetailMatchMetricTier.Tier3:
            return RetailMatchDynamicTextEnum.Similar;

        default:
            return RetailMatchDynamicTextEnum.VerySimilar;
    }
}

export function getRetailMatchComparableVerbiage(
    value: number
): RetailMatchDynamicTextEnum {
    const tierLevel: RetailMatchMetricTier = getRetailMatchMetricTierLevel(value);

    switch (tierLevel) {
        case RetailMatchMetricTier.Tier1:
            return RetailMatchDynamicTextEnum.Low;

        case RetailMatchMetricTier.Tier2:
            return RetailMatchDynamicTextEnum.SlightlyLower;

        case RetailMatchMetricTier.Tier3:
            return RetailMatchDynamicTextEnum.Comparable;

        default:
            return RetailMatchDynamicTextEnum.High;
    }
}

export function getRetailMatchAverageVerbiage(
    value: number
): RetailMatchDynamicTextEnum {
    const tierLevel: RetailMatchMetricTier = getRetailMatchMetricTierLevel(value);

    switch (tierLevel) {
        case RetailMatchMetricTier.Tier1:
            return RetailMatchDynamicTextEnum.Low;

        case RetailMatchMetricTier.Tier2:
            return RetailMatchDynamicTextEnum.BelowAverage;

        case RetailMatchMetricTier.Tier3:
            return RetailMatchDynamicTextEnum.Average;

        default:
            return RetailMatchDynamicTextEnum.High;
    }
}

export const getBarWidth = (index: number): number => {
    const tier: RetailMatchMetricTier = getRetailMatchMetricTierLevel(index);
    let value = 0;
    switch (tier) {
        case RetailMatchMetricTier.Tier1: {
            value = 15;
            break;
        }
        case RetailMatchMetricTier.Tier2: {
            value = 45;
            break;
        }
        case RetailMatchMetricTier.Tier3: {
            value = 65;
            break;
        }
        case RetailMatchMetricTier.Tier4: {
            value = 90;
            break;
        }
    }
    return value;
};

export const getDateBackVerbiage = (
    startDate: string,
    endDate: string
): string => {
    const formattedStart: Date = new Date(startDate);
    const formattedEnd: Date = new Date(endDate);
    let message = "";

    if (
        formattedStart.getFullYear() === 2019
    && formattedEnd.getFullYear() === 2019
    ) {
        message = "in all of 2019";
    } else {
        message = `between ${formattedStart.toLocaleDateString()} and ${formattedEnd.toLocaleDateString()}`;
    }

    return message;
};

export const getBenchmarkAddressOverride = (
    jobResult: IRetailMatchJobResult,
    benchmarkRecord: IStoreScoreRecord
): IStoreScoreRecord => {
    return {
        ...benchmarkRecord,
        addr: jobResult?.job.addressOverride || benchmarkRecord?.addr,
        city: jobResult?.job.cityOverride || benchmarkRecord?.city,
        st: jobResult?.job.stateOverride || benchmarkRecord?.st,
        zip: jobResult?.job.zipcodeOverride || benchmarkRecord?.zip,
    };
};

export const brandOverviewRecord = (
    brandId: string,
    allOverviews: IRetailMatchOverview[]
) => {
    return allOverviews.find((record) => {
        return record.brandId === brandId;
    });
};
